module.exports = __webpack_public_path__ + "static/img/2.3a63503.png";


//////////////////
// WEBPACK FOOTER
// ./static/honour/2.png
// module id = 6W5f
// module chunks = 1